import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import Footer from "../../components/Footer";
import CourseNavigation from "../../components/institute/CourseNavigation";
import LearningBenefits from "../../components/institute/LearningBenefits";
import InstituteCTA from "../../components/institute/InstituteCTA";
import { instituteCourseMap } from "../../components/institute/courseConfig";
import {
  MernStackSection,
  DigitalMarketingSection,
  UiUxSection,
  PythonFullStackSection,
  TallyPrimeSection,
  BasicComputersSection,
  CyberSecuritySection,
} from "../../components/institute/InstituteCourses";

const courseComponents = {
  "mern-stack": MernStackSection,
  "digital-marketing": DigitalMarketingSection,
  "ui-ux": UiUxSection,
  "python-full-stack": PythonFullStackSection,
  "tally-prime": TallyPrimeSection,
  "basic-computers": BasicComputersSection,
  "cyber-security": CyberSecuritySection,
};

export default function CourseDetail() {
  const { courseSlug } = useParams();
  const course = instituteCourseMap[courseSlug];
  const CourseComponent = courseComponents[courseSlug];

  useEffect(() => {
    if (!course) return;

    document.title = course.seoTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = course.seoDescription;
  }, [course]);

  if (!course || !CourseComponent) {
    return <Navigate to="/institute" replace />;
  }

  return (
    <main className="overflow-hidden bg-[#f6f6f6] text-[#111111]">
      <div className="pt-[100px]">
        <CourseNavigation />
      </div>
      <CourseComponent detail />
      <LearningBenefits />
      <InstituteCTA />
      <Footer />
    </main>
  );
}
